export const ERRORS = {
	LLS: 'LLS',
	DOWNLOAD: 'DOWNLOAD',
	GENERAL: 'GENERAL'
};
export const CAPTCHA_ERROR = 'captcha';
export const CURRENCIES = [
	{
		currencyCode: 'HUF',
		hungarianName: 'Magyar forint'
	},
	{
		currencyCode: 'EUR',
		hungarianName: 'Euro'
	},
	{
		currencyCode: 'USD',
		hungarianName: 'Amerikai dollár'
	},
	{
		currencyCode: 'AUD',
		hungarianName: 'Ausztrál dollár'
	},
	{
		currencyCode: 'BGN',
		hungarianName: 'Bolgár leva'
	},
	{
		currencyCode: 'CAD',
		hungarianName: 'Kanadai dollár'
	},
	{
		currencyCode: 'CHF',
		hungarianName: 'Svájci frank '
	},
	{
		currencyCode: 'CNY',
		hungarianName: 'Kínai juan'
	},
	{
		currencyCode: 'CZK',
		hungarianName: 'Cseh korona'
	},
	{
		currencyCode: 'DKK',
		hungarianName: 'Dán korona'
	},
	{
		currencyCode: 'GBP',
		hungarianName: 'Angol font'
	},
	{
		currencyCode: 'JPY',
		hungarianName: 'Japán yen'
	},
	{
		currencyCode: 'NOK',
		hungarianName: 'Norvég korona'
	},
	{
		currencyCode: 'PLN',
		hungarianName: 'Lengyel zloty'
	},
	{
		currencyCode: 'RON',
		hungarianName: 'Új román lej'
	},
	{
		currencyCode: 'RSD',
		hungarianName: 'Szerb dinár'
	},
	{
		currencyCode: 'SEK',
		hungarianName: 'Svéd korona'
	},
	{
		currencyCode: 'TRY',
		hungarianName: 'Új török lira'
	}
];
export const BANK_ACCOUNT_SIXTEEN_NUMBERS_REGEXP = '^\\d{5}-\\d{8}$';
export const BANK_ACCOUNT_TWENTY_FOUR_NUMBERS_REGEXP = '^\\d{5}-\\d{8}-\\d{8}$';
export const ADDRES_DETAILS_REGEXP = '^(?=.*\\d)[\\p{L}\\s\\d/,.\\-]{1,20}$';
